module.exports = __webpack_public_path__ + "static/media/my529LogoColorsTransp.015e2964.png";